import { FC } from 'react';

type Props = {
  status: string;
};

const LoanOfferStatusBadge: FC<Props> = ({ status }) => {
  return <span className={`badge badge-light-${status.toLowerCase()} fs-7 fw-bold`}>{status.toLowerCase()}</span>;
};

export default LoanOfferStatusBadge;
